import React, { useState, useEffect } from 'react';
import { useCurrentProjectIdContext } from "./project-builder-main.jsx";
import { getProject } from '../../../apis/project-builder';
import { useQuery } from '@tanstack/react-query';
//import { useAddAttachment } from '../../../components/project-builder-custom-hooks';
//import Loader from '../../../../shared/react/components/loader.jsx';
import AddRemoveDocumentsButton from './add-remove-documents-button.jsx';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';


export default function AttachmentsListItem({ attachment, deleteOnly, readOnly }) {

    const isDocument = attachment.IsDocument;
    //const isVideo = attachment.IsVideo;

    const { currentProjectId } = useCurrentProjectIdContext();

    const { data, isSuccess } = useQuery(['project-detail', currentProjectId], () => getProject(currentProjectId));

    const [isAdded, setIsAdded] = useState(false);

    const checkIfAdded = () => {
        if (isDocument) {
            data.attachements.some(attachmentItem => attachmentItem.documentLocalSlug === attachment.documentLocalSlug) ? setIsAdded(true) : setIsAdded(false);
            return;
        }

        data.attachements.some(attachmentItem => attachmentItem.videoNodeId === attachment.videoNodeId) ? setIsAdded(true) : setIsAdded(false);
    };

    checkIfAdded();
    useEffect(() => {
        //checkIfAdded();
    }, [])

    return (
        <>
            {isSuccess
            ? <li key={attachment.id} className={`${isAdded ? "isAdded" : ""}`}>
                    {isDocument ? (
                        <div className="icon-container">
                            <svg class="icon icon-document-file-pdf">
                                <use href="#icon-document-file-pdf"></use>
                            </svg>
                        </div>
                    ) : (
                        <div className="icon-container icon-container--video">
                            {/*<svg class="icon icon-play card-media-play">*/}
                            {/*    <use href="#icon-play"></use>*/}
                                {/*</svg>*/}
                                <PlayCircleOutlineIcon />
                        </div>
                    )}
                    <a href={attachment.linkUrl} target="_blank" className="attachment-title">
                        <span>{attachment.headline}: </span> {attachment.description}
                    </a>

                {readOnly
                    ? null
                        : <AddRemoveDocumentsButton itemSlug={attachment.documentLocalSlug} videoNodeId={attachment.videoNodeId} deleteOnly={deleteOnly} isAdded={isAdded} setIsAdded={setIsAdded} />
                }

            </li >
            : null
            }
        </>
    );
}